import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '@modules/auth/presentation/hooks/useAuth';

/** Menú compacto para las páginas públicas y de contratación. */
export function MobilePublicNav() {
  const [open, setOpen] = useState(false);
  const { isAuthenticated, user } = useAuth();
  const linkClass = 'block rounded-lg px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100';
  return (
    <div className="relative shrink-0 lg:hidden">
      <button type="button" onClick={() => setOpen(!open)} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} className="flex h-11 w-11 items-center justify-center rounded-full text-gray-700 hover:bg-gray-100">
        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>
      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-56 max-w-[calc(100vw-3rem)] rounded-xl border border-gray-100 bg-white p-2 shadow-lg">
          <Link to="/inicio" onClick={() => setOpen(false)} className={linkClass}>Inicio</Link>
          <Link to="/planes" onClick={() => setOpen(false)} className={linkClass}>Ver planes</Link>
          {isAuthenticated ? (
            <>
              <Link to="/sucursal-virtual" onClick={() => setOpen(false)} className={linkClass}>Mi cuenta</Link>
              {user?.role === 'ADMIN' && <Link to="/admin" onClick={() => setOpen(false)} className={linkClass}>Administración</Link>}
            </>
          ) : (
            <>
              <Link to="/iniciar-sesion" onClick={() => setOpen(false)} className={linkClass}>Iniciar sesión</Link>
              <Link to="/registro" onClick={() => setOpen(false)} className={linkClass}>Registrarse</Link>
            </>
          )}
        </div>
      )}
    </div>
  );
}
